<template>
  <v-row justify="center">
    <!-- <alert
      :data="errorData"
      :active="activeAlert"
      :colorAlert="colorAlert"
      @dialog:change="eventdialog"
    /> -->
    <v-dialog :value="updateClient" @click:outside="eventdialog" scrollable max-width="768">
      <ValidationObserver ref="obs" v-slot="{ passes }">
        <v-card>
          <v-progress-linear v-if="loading" indeterminate color="primary" rounded height="6"></v-progress-linear>

          <v-card-title class="pa-0 shadow-1">
            <v-img
              :src="require('@/assets/illustrations/bg_modal_card.svg')"
              cover
              position="left bottom"
              class="align-center"
              height="65px"
            >
              <v-card-title class="font-weight-medium primary--text">
                Editar cliente
              </v-card-title>
            </v-img>
          </v-card-title>

          <vuescroll
            :ops="{
              bar: { background: '#bacfcec0', keepShow: true },
            }"
          >
            <v-card-text :style="`max-height: ${DIALOG_MAX_HEIGHT}`">
              <v-form>
                <v-row dense>
                  <v-col cols="12">
                    <ValidationProvider name="nombre" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Nombre"
                        name="nombre"
                        prepend-inner-icon="mdi-account"
                        type="text"
                        color="blue-grey"
                        v-model="data.name"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="usuario" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Usuario"
                        name="usuario"
                        prepend-inner-icon="mdi-account"
                        color="blue-grey"
                        v-model="data.user"
                        :error-messages="errors"
                        @click:append="showPassword = !showPassword"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="correo electrónico" rules="email|required" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Correo electrónico"
                        name="email"
                        prepend-inner-icon="mdi-email"
                        type="text"
                        color="blue-grey"
                        v-model="data.email"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="contraseña" rules="max:10" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Contraseña"
                        name="password"
                        prepend-inner-icon="mdi-lock"
                        :append-icon="showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                        :type="showPassword ? 'text' : 'password'"
                        color="blue-grey"
                        v-model="data.password"
                        :error-messages="errors"
                        @click:append="showPassword = !showPassword"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider name="Cantidad de Agentes" rules="numeric" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Cantidad de Agentes"
                        prepend-inner-icon="mdi-account"
                        color="blue-grey"
                        v-model="data.agent"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider name="Cantidad de Supervisores" rules="numeric" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Cantidad de Supervisores"
                        prepend-inner-icon="mdi-account-arrow-up"
                        color="blue-grey"
                        v-model="data.supervisor"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider name="Plan" rules="required" v-slot="{ errors }">
                      <v-select
                        :items="[
                          { id: 1, name: 'Plan Pro' },
                          { id: 2, name: 'Plan Básico' },
                          { id: 3, name: 'Plan Demo' },
                        ]"
                        item-text="name"
                        item-value="id"
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Plan"
                        name="Plan"
                        prepend-inner-icon="mdi-crop-landscape"
                        color="blue-grey"
                        v-model="data.plan_id"
                        :error-messages="errors"
                      ></v-select>
                    </ValidationProvider>
                  </v-col>

                  <!-- Has Signature -->
                  <v-col cols="12">
                    <ValidationProvider name="Tiene firma?" rules="required">
                      <v-switch
                        class="ml-3"
                        color="success"
                        v-model="data.has_signature"
                        inset
                        label="Tiene firma"
                      ></v-switch>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="IP de grabación" rules="required" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="IP de grabación"
                        name="ip_recording"
                        prepend-inner-icon="mdi-microphone"
                        color="blue-grey"
                        v-model="data.ip_recording"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="dirección IP" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Dirección IP"
                        name="ip"
                        prepend-inner-icon="mdi-web"
                        color="blue-grey"
                        v-model="data.ip"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="nombre de BD" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Nombre de BD"
                        name="nameBd"
                        prepend-inner-icon="mdi-database"
                        color="blue-grey"
                        v-model="data.nameBd"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="puerto de BD" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Puerto de BD"
                        name="portBd"
                        prepend-inner-icon="mdi-network"
                        color="blue-grey"
                        v-model="data.port"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-card-title class="font-weight-medium primary--text">
                  Configuración de socket
                </v-card-title>
                <v-row dense>
                  <v-col cols="12">
                    <ValidationProvider name="usuario_sokect" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Usuario"
                        name="usuario_sokect"
                        prepend-inner-icon="mdi-account"
                        color="blue-grey"
                        v-model="data.user_sokect"
                        :error-messages="errors"
                        @click:append="showPassword = !showPassword"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="contraseñas_sokect" v-slot="{ errors }">
                      <v-text-field
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Contraseña"
                        name="password"
                        prepend-inner-icon="mdi-lock"
                        :append-icon="showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                        :type="showPassword ? 'text' : 'password'"
                        color="blue-grey"
                        v-model="data.clave_sokect"
                        :error-messages="errors"
                        @click:append="showPassword = !showPassword"
                      ></v-text-field>
                    </ValidationProvider>

                    <v-slide-y-transition>
                      <p v-if="data.clave_sokect" class="grey--text caption pb-3">
                        <v-icon small left color="blue-grey">mdi-information</v-icon>Recuerde anotar la contraseña para
                        entregársela al usuario.
                      </p>
                    </v-slide-y-transition>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="dirección IP sokect" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Dirección IP"
                        name="ip_socket"
                        prepend-inner-icon="mdi-web"
                        color="blue-grey"
                        v-model="data.ip_sokect"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="puerto_sokect" v-slot="{ errors }">
                      <v-text-field
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Puerto de BD"
                        name="portBd"
                        prepend-inner-icon="mdi-network"
                        color="blue-grey"
                        v-model="data.port_sokect"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>

                <v-card-title class="font-weight-medium primary--text">
                  Avanzado
                </v-card-title>
                <v-row dense>
                  <v-col cols="12">
                    <ValidationProvider name="URL del Web Socket" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="URL del Web Socket"
                        name="web_socket_server-url"
                        prepend-inner-icon="mdi-link"
                        color="blue-grey"
                        v-model="data.web_socket_server_url"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="Dominio de bitrix" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Dominio de bitrix"
                        name="domain_bitrix"
                        prepend-inner-icon="mdi-domain"
                        color="blue-grey"
                        v-model="data.domain_bitrix"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="Clave de bitrix" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Clave de bitrix"
                        name="key_bitrix"
                        prepend-inner-icon="mdi-key"
                        color="blue-grey"
                        v-model="data.key_bitrix"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>

                <v-card-title class="font-weight-medium primary--text">
                  Jornada
                </v-card-title>

                <v-row>
                  <v-col cols="12">
                    <ValidationProvider name="Jornada">
                      <journal-select
                        :key="data.id"
                        :initialValue="data.journal"
                        @data:change="handleJournalChange"
                      ></journal-select>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </vuescroll>

          <v-divider></v-divider>

          <v-card-actions class="mx-2">
            <v-spacer></v-spacer>
            <v-hover v-slot:default="{ hover }">
              <v-btn text rounded class="mr-1" :color="hover ? 'error' : 'grey'" @click="eventdialog">Cancelar</v-btn>
            </v-hover>

            <v-hover v-slot:default="{ hover }">
              <v-btn
                rounded
                :loading="loading"
                :disabled="loading"
                color="success"
                :class="hover ? 'shadow-2' : 'shadow-4'"
                class="px-8"
                @click="passes(updateForm)"
                >Actualizar</v-btn
              >
            </v-hover>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </v-row>
</template>

<script>
import vuescroll from "vuescroll";
import JournalSelect from "./Journal/JournalSelect.vue";
import { DIALOG_MAX_HEIGHT } from "@/utils";

export default {
  components: {
    vuescroll,
    JournalSelect,
  },
  props: ["updateClient", "data"],
  data() {
    return {
      DIALOG_MAX_HEIGHT,
      loading: false,
      showPassword: false,
      errorData: "",
      activeAlert: "",
      colorAlert: "",
    };
  },
  methods: {
    eventdialog() {
      this.$emit("dialog:change", "cerrar");
    },
    async updateForm() {
      try {
        const data = {
          value: {
            ClientName: this.data.name,
            ClientUser: this.data.user,
            ClientPassword: this.data.password,
            ClientEmail: this.data.email,
            ip_recording: this.data.ip_recording,
            ClientIP: this.data.ip,
            ClientNameBd: this.data.nameBd,
            ClientPort: this.data.port,
            ip_sokect: this.data.ip_sokect,
            user_sokect: this.data.user_sokect,
            clave_sokect: this.data.clave_sokect,
            port_sokect: this.data.port_sokect,
            agent: Number(this.data.agent),
            supervisor: Number(this.data.supervisor),
            plan_id: this.data.plan_id,
            web_socket_server_url: this.data.web_socket_server_url,
            domain_bitrix: this.data.domain_bitrix,
            key_bitrix: this.data.key_bitrix,
            has_signature: this.data.has_signature,
            journal: JSON.stringify(this.data.journal),
          },
          id: this.data.id,
        };
        await this.$store.dispatch("clients/EDIT_CLIENTS", data);
        this.$snotify.success("El cliente se ha actualizado con éxito.", "¡Hecho!");
        // this.errorData = response.data;
        // this.activeAlert = true;
        // this.colorAlert = "blue";
        this.$emit("dialog:change", "Actualizado");
      } catch (error) {
        this.$snotify.error(error.response.data, "¡Error!");
        // this.errorData = error.response.data;
        // this.activeAlert = true;
        // this.colorAlert = "red";
      }
    },

    handleJournalChange(newData) {
      this.data.journal = { ...newData };
    },
  },
};
</script>

<style></style>
